<script>
	import configuration from '../configuration.json';
    import app from '../data/app.svelte.js';
    import persistent from '../data/persistent.svelte';
    import { currentSession, currentSessionId } from '../data/session.svelte.js';

    import { _ } from 'svelte-i18n';
    import { first, next, previous, goto, replace } from '../helpers/navigation.svelte.js';

    import Section from '../components/Section.svelte';
    import Markdown from '../components/Markdown.svelte';
    import Navigation from '../components/Navigation.svelte';
    import Button from '../components/Button.svelte';

    import Icon from '../components/Icon.svelte';
    import arrowRightIcon from '../assets/icons/arrow-right.svg?raw';


    const current = 'message';

    // Redirect to first step if emergency message is no longer enabled
    if (!app.settings.emergency.enabled) {
        replace(first(), 'right');
    }

    function goNext() {
        goto(next(current), 'right');
    }

</script>

<svelte:head>
    <title>{$_('appointment_title')} - {app.settings.emergency.title}</title>
</svelte:head>

<Section>
    <h2>{app.settings.emergency.title}</h2>
    
    <div class="message-content">
        <Markdown source={app.settings.emergency.contents} />
    </div>

    {#if !app.settings.emergency.blocked}
        <Navigation>
            <Button color="accent" onclick={goNext}>
                {$_('continue')}
                <Icon data={arrowRightIcon} />
            </Button>
        </Navigation>
    {/if}
</Section>

<style>

    h2 {
        font-family: var(--theme-alt-font-family);
        font-weight: normal;
        font-size: 2em;
        opacity: 0.4;

        margin: 0.5em 0 0.4em;
    }

    .message-content {
        font-size: 1em;
        line-height: 1.45;
    }

</style>